import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { menuData } from './MenuData';
export function Menu() {
  const [activeTab, setActiveTab] = useState(menuData[0].id);
  const activeCategory = menuData.find(cat => cat.id === activeTab) || menuData[0];
  return <section id="menu" className="py-20 md:py-32 bg-brand-tertiary" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">

        {/* Title */}
        <div className="text-center mb-12" data-id="element-231">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-4" data-id="element-232">
            Nuestra Propuesta Gastronómica
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-233"></div>
        </div>

        {/* Tabs - CORREGIDO: flex-wrap para que no se corten */}
        <div className="mb-12 pb-4 border-b border-brand-gold/20" data-id="element-234">
          <div className="flex flex-wrap gap-2 justify-center" data-id="element-235">
            {menuData.map(category => <button key={category.id} onClick={() => setActiveTab(category.id)} className={`whitespace-nowrap px-4 py-2 text-sm font-medium
                  transition-all duration-300 rounded-full border
                  ${activeTab === category.id ? 'bg-brand-gold text-brand-primary border-brand-gold' : 'bg-transparent text-brand-cream/70 border-brand-gold/30 hover:border-brand-gold hover:text-brand-cream'}`} data-id="element-236">
                {category.name}
                {activeTab === category.id}
              </button>)}
          </div>
        </div>

        {/* Content */}
        <div className="min-h-[600px]" data-id="element-237">
          <AnimatePresence mode="wait" data-id="element-238">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.4
          }} data-id="element-239">
              {/* Category Header Image */}
              {activeCategory.image && <div className="w-full h-64 md:h-80 rounded-2xl overflow-hidden mb-12 relative" data-id="element-240">
                  <img src={activeCategory.image} alt={activeCategory.name} className="w-full h-full object-cover" data-id="element-241" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-tertiary via-transparent to-transparent" data-id="element-242" />
                </div>}

              {/* Items Grid */}
              {activeCategory.items && activeCategory.items.length > 0 && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-243">
                  {activeCategory.items.map((item, idx) => <div key={idx} className="bg-brand-primary p-6 rounded-xl border border-brand-gold/20 hover:border-brand-gold transition-all duration-300 hover:shadow-lg hover:shadow-amber-900/20 group" data-id="element-244">
                      <div className="flex justify-between items-start mb-3" data-id="element-245">
                        <h4 className="text-lg font-serif text-brand-cream group-hover:text-brand-gold transition-colors" data-id="element-246">
                          {item.name}
                        </h4>
                        <span className="text-brand-gold font-bold whitespace-nowrap ml-2" data-id="element-247">
                          {item.price}
                        </span>
                      </div>
                      {item.description && <p className="text-brand-cream/60 text-sm leading-relaxed mt-auto" data-id="element-248">
                          {item.description}
                        </p>}
                    </div>)}
                </div>}

              {/* Subcategories */}
              {activeCategory.subcategories && activeCategory.subcategories.map((sub, subIdx) => <div key={subIdx} className="mb-12" data-id="element-249">
                    <h3 className="text-2xl font-serif text-brand-gold mb-6 border-b border-brand-gold/20 pb-2 inline-block" data-id="element-250">
                      {sub.name}
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-251">
                      {sub.items.map((item, idx) => <div key={idx} className="bg-brand-primary p-6 rounded-xl border border-brand-gold/20 hover:border-brand-gold transition-all duration-300 hover:shadow-lg hover:shadow-amber-900/20 group" data-id="element-252">
                          <div className="flex justify-between items-start mb-3" data-id="element-253">
                            <h4 className="text-lg font-serif text-brand-cream group-hover:text-brand-gold transition-colors" data-id="element-254">
                              {item.name}
                            </h4>
                            <span className="text-brand-gold font-bold whitespace-nowrap ml-2" data-id="element-255">
                              {item.price}
                            </span>
                          </div>
                          {item.description && <p className="text-brand-cream/60 text-sm leading-relaxed mt-auto" data-id="element-256">
                              {item.description}
                            </p>}
                        </div>)}
                    </div>
                  </div>)}

            </motion.div>
          </AnimatePresence>
        </div>

      </div>
    </section>;
}